import {AsyncPipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle,} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatListItemIcon, MatListItemTitle, MatListOption, MatSelectionList,} from '@angular/material/list';
import {Badge, BadgeService} from '@app/badge/badge.service';
import {TagInputComponent} from '@app/tag/tag-input/tag-input.component';
import {TagService} from '@app/tag/tag.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-badge-dialog',
    templateUrl: './badge-dialog.component.html',
    styleUrls: ['./badge-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatSelectionList,
        MatListOption,
        MatListItemTitle,
        MatListItemIcon,
        MatIcon,
        ReactiveFormsModule,
        TagInputComponent,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        AsyncPipe,
    ],
})
export class BadgeDialogComponent implements OnInit {
    @ViewChild('file', { static: true }) file;

    public form: UntypedFormGroup;
    public badges$: Observable<Badge[]>;
    public tag: string;
    public badgeimage: any;
    public imageurl;
    public cache: Badge[];

    constructor(
        private badgeservice: BadgeService,
        private tagService: TagService,
        private fb: UntypedFormBuilder,
    ) {
        this.tag = null;
        this.badgeimage = null;
        this.imageurl = null;

        this.form = this.fb.group({
            id: '',
            tag: ['', Validators.required],
            image: ['', Validators.required],
            image_file: null,
        });
    }

    ngOnInit(): void {
        this.badges$ = this.badgeservice.badges;
    }

    selectBadge(badge: Badge) {
        if (badge === null) {
            // Add new
            this.form.reset();
            this.imageurl = '';
        } else {
            this.form.setValue({
                id: badge.id,
                tag: badge.tag,
                image: badge.image,
                image_file: null,
            });
            this.imageurl = badge.image;
        }

        this.badgeimage = null;
    }

    setTag(tagName: string) {
        const found = this.badgeservice.getByTag(tagName);
        if (found) {
            this.selectBadge(found);
            return;
        }

        this.tagService.resolveName(tagName).subscribe((tag) => {
            this.badgeimage = null;
            this.imageurl = null;
            this.form.patchValue({
                tag: tag,
                image: null,
            });
        });
    }

    addFiles() {
        this.file.nativeElement.click();
    }

    onFilesAdded() {
        this.form.patchValue({
            image: this.file.nativeElement.files[0].name,
            image_file: this.file.nativeElement.files[0],
        });

        const reader = new FileReader();
        reader.readAsDataURL(this.file.nativeElement.files[0]);
        reader.onload = (event) => {
            this.badgeimage = reader.result;
        };
    }

    save() {
        const value = this.form.value;

        this.badgeservice.update(value.tag.id, value.image_file);
    }

    deleteBadge() {
        const value = this.form.value;
        if (value.id) {
            this.badgeservice.delete(value.id);
        }
        this.form.reset();
        this.imageurl = '';
    }
}
